// extracted by mini-css-extract-plugin
export var container = "style-module--container--w48zA";
export var desc = "style-module--desc--bcMyF";
export var heading = "style-module--heading--12-bZ";
export var trainercontainer = "style-module--trainercontainer--Vk-bx";